<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0 font-semibold">Notice Board</h5>
      </div>
      <div class="trezo-card-subtitle">
        <a
          href="#"
          class="inline-block relative ltr:pr-[13px] rtl:pl-[13px] leading-none transition-all hover:text-primary-500"
        >
          View All
          <i
            class="ri-arrow-right-s-line absolute top-1/2 -translate-y-1/2 ltr:-right-[8px] rtl:-left-[8px] text-[23px] -mt-px"
          ></i>
        </a>
      </div>
    </div>

    <div class="trezo-card-content -mx-[20px] md:-mx-[25px]">
      <div
        class="relative border-b border-gray-50 dark:border-[#172036] pb-[10px] mb-[11px] px-[70px] md:px-[76px] last:border-b-0 last:pb-0 last:mb-0"
      >
        <div
          class="w-[40px] h-[40px] bg-purple-500 rounded-full flex items-center justify-center absolute ltr:left-[20px] ltr:md:left-[25px] rtl:right-[20px] rtl:md:right-[25px] mt-[2px]"
        >
          <img src="@/assets/images/icons/note.svg" alt="note" />
        </div>
        <h6 class="text-base font-medium mb-[4px]">
          <a
            href="#"
            class="text-gray-700 dark:text-gray-400 transition-all hover:text-primary-500"
          >
            Science Fair Registration
          </a>
        </h6>
        <p class="text-xs max-w-[166px] leading-[1.4] mb-[4px]">
          Registration for the annual Science Fair
        </p>
        <span
          class="block relative text-primary-500 text-xs ltr:pl-[16px] rtl:pr-[16px]"
        >
          <i
            class="ri-calendar-line absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-px"
          ></i>
          October 28, 2024
        </span>
        <a
          href="javascript:void(0);"
          class="inline-block absolute ltr:right-[20px] rtl:left-[20px] ltr:md:right-[25px] rtl:md:left-[25px] top-1/2 -translate-y-1/2 -mt-[10px] w-[40px] h-[40px] md:w-[43px] md:h-[43px] text-center text-gray-400 transition-all border border-gray-100 dark:border-[#172036] rounded-full hover:bg-primary-500 hover:border-primary-500 hover:text-white"
        >
          <i
            class="material-symbols-outlined absolute left-0 right-0 !text-[22px] top-1/2 -translate-y-1/2"
          >
            arrow_outward
          </i>
        </a>
      </div>

      <div
        class="relative border-b border-gray-50 dark:border-[#172036] pb-[10px] mb-[11px] px-[70px] md:px-[76px] last:border-b-0 last:pb-0 last:mb-0"
      >
        <div
          class="w-[40px] h-[40px] bg-primary-500 rounded-full flex items-center justify-center absolute ltr:left-[20px] ltr:md:left-[25px] rtl:right-[20px] rtl:md:right-[25px] mt-[2px]"
        >
          <img src="@/assets/images/icons/video-chat.svg" alt="video-chat" />
        </div>
        <h6 class="text-base font-medium mb-[4px]">
          <a
            href="#"
            class="text-gray-700 dark:text-gray-400 transition-all hover:text-primary-500"
          >
            Parent-Teacher Meeting
          </a>
        </h6>
        <p class="text-xs max-w-[166px] leading-[1.4] mb-[4px]">
          The Parent-Teacher meeting for Term 1 will take place
        </p>
        <span
          class="block relative text-primary-500 text-xs ltr:pl-[16px] rtl:pr-[16px]"
        >
          <i
            class="ri-calendar-line absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-px"
          ></i>
          November 1, 2024
        </span>
        <a
          href="javascript:void(0);"
          class="inline-block absolute ltr:right-[20px] rtl:left-[20px] ltr:md:right-[25px] rtl:md:left-[25px] top-1/2 -translate-y-1/2 -mt-[10px] w-[40px] h-[40px] md:w-[43px] md:h-[43px] text-center text-gray-400 transition-all border border-gray-100 dark:border-[#172036] rounded-full hover:bg-primary-500 hover:border-primary-500 hover:text-white"
        >
          <i
            class="material-symbols-outlined absolute left-0 right-0 !text-[22px] top-1/2 -translate-y-1/2"
          >
            arrow_outward
          </i>
        </a>
      </div>

      <div
        class="relative border-b border-gray-50 dark:border-[#172036] pb-[10px] mb-[11px] px-[70px] md:px-[76px] last:border-b-0 last:pb-0 last:mb-0"
      >
        <div
          class="w-[40px] h-[40px] bg-orange-500 rounded-full flex items-center justify-center absolute ltr:left-[20px] ltr:md:left-[25px] rtl:right-[20px] rtl:md:right-[25px] mt-[2px]"
        >
          <img src="@/assets/images/icons/ball.svg" alt="ball" />
        </div>
        <h6 class="text-base font-medium mb-[4px]">
          <a
            href="#"
            class="text-gray-700 dark:text-gray-400 transition-all hover:text-primary-500"
          >
            Winter Sports Tryouts
          </a>
        </h6>
        <p class="text-xs max-w-[166px] leading-[1.4] mb-[4px]">
          Tryouts for the winter sports teams will begin on
        </p>
        <span
          class="block relative text-primary-500 text-xs ltr:pl-[16px] rtl:pr-[16px]"
        >
          <i
            class="ri-calendar-line absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-px"
          ></i>
          November 12, 2024
        </span>
        <a
          href="javascript:void(0);"
          class="inline-block absolute ltr:right-[20px] rtl:left-[20px] ltr:md:right-[25px] rtl:md:left-[25px] top-1/2 -translate-y-1/2 -mt-[10px] w-[40px] h-[40px] md:w-[43px] md:h-[43px] text-center text-gray-400 transition-all border border-gray-100 dark:border-[#172036] rounded-full hover:bg-primary-500 hover:border-primary-500 hover:text-white"
        >
          <i
            class="material-symbols-outlined absolute left-0 right-0 !text-[22px] top-1/2 -translate-y-1/2"
          >
            arrow_outward
          </i>
        </a>
      </div>

      <div
        class="relative border-b border-gray-50 dark:border-[#172036] pb-[10px] mb-[11px] px-[70px] md:px-[76px] last:border-b-0 last:pb-0 last:mb-0"
      >
        <div
          class="w-[40px] h-[40px] bg-secondary-500 rounded-full flex items-center justify-center absolute ltr:left-[20px] ltr:md:left-[25px] rtl:right-[20px] rtl:md:right-[25px] mt-[2px]"
        >
          <img src="@/assets/images/icons/celebration.svg" alt="celebration" />
        </div>
        <h6 class="text-base font-medium mb-[4px]">
          <a
            href="#"
            class="text-gray-700 dark:text-gray-400 transition-all hover:text-primary-500"
          >
            School Holiday Reminder
          </a>
        </h6>
        <p class="text-xs max-w-[166px] leading-[1.4] mb-[4px]">
          A reminder that school will be closed on November
        </p>
        <span class="block relative text-primary-500 text-xs ltr:pl-[16px]">
          <i
            class="ri-calendar-line absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-px"
          ></i>
          November 28, 2024
        </span>
        <a
          href="javascript:void(0);"
          class="inline-block absolute ltr:right-[20px] rtl:left-[20px] ltr:md:right-[25px] rtl:md:left-[25px] top-1/2 -translate-y-1/2 -mt-[10px] w-[40px] h-[40px] md:w-[43px] md:h-[43px] text-center text-gray-400 transition-all border border-gray-100 dark:border-[#172036] rounded-full hover:bg-primary-500 hover:border-primary-500 hover:text-white"
        >
          <i
            class="material-symbols-outlined absolute left-0 right-0 !text-[22px] top-1/2 -translate-y-1/2"
          >
            arrow_outward
          </i>
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NoticeBoard",
});
</script>
